document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("read-more").forEach((el) => {
    const content = el.querySelector(".read-more__content");
    const toggleBtn = el.querySelector(".read-more__toggle");

    if (!content || !toggleBtn) return;

    content.querySelectorAll("a[href^='#']").forEach((link) => {
      link.addEventListener("click", (e) => {
        if (!content.classList.contains(el.toggleClass)) return;

        // e.preventDefault();
        toggleBtn.click();
      });
    });
  });
});


(function () {
  function debounce(fn, wait){ let t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); }; }

  const HOME_SVG = '<div class="icon-home-wrap"><svg class="icon-home" fill="#000000" id="Capa_1" width="15" height="15" viewBox="0 0 495.398 495.398" aria-hidden="true"><g><g><g><path d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391 v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158 c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747 c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"/><path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401 c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79 c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"/></g></g></g></svg></div>';

  function processBreadcrumbs() {
    const nav = document.querySelector('nav.breadcrumbs');
    if (!nav) return;

    if (!nav.dataset.origHtml) {
      nav.dataset.origHtml = nav.innerHTML;
    }

    const isMobile = window.innerWidth <= 768;

    if (!isMobile) {
      if (nav.innerHTML !== nav.dataset.origHtml) {
        nav.innerHTML = nav.dataset.origHtml;
      }
      return;
    }

    if (nav._mobileHTML) {
      if (nav.innerHTML !== nav._mobileHTML) {
        nav.innerHTML = nav._mobileHTML;
      }
      return;
    }

    const source = nav.dataset.origHtml;
    const tmp = document.createElement('div');
    tmp.innerHTML = source;

    const allItems = Array.from(tmp.querySelectorAll('.reversed-link, .breadcrumbs--last'));
    if (allItems.length === 0) return;

    const home = allItems[0];
    const homeText = (home.textContent || '').trim();

    const homeClone = home.cloneNode(true);
    homeClone.innerHTML = HOME_SVG + '<span class="breadcrumbs__home-text">' + (homeText || '') + '</span>';

    let items = allItems.slice(1);

    const path = (window.location.pathname || '').toLowerCase();
    const isProductPage = path.indexOf('/products/') !== -1;
    const isCollectionPage = path.indexOf('/collections/') !== -1;

    // if (isProductPage && items.length > 0) {
    //   items.pop();
    // }

    let visibleCollections = items.length <= 2 ? items : items.slice(-2);

    let html = homeClone.outerHTML;
    visibleCollections.forEach((node) => {
      html += '<span class="breadcrumbs--sep" aria-hidden="true"></span>' + node.outerHTML;
    });

    nav._mobileHTML = html;
    nav.innerHTML = nav._mobileHTML;
  }

  document.addEventListener('DOMContentLoaded', processBreadcrumbs);
  window.addEventListener('resize', debounce(processBreadcrumbs, 50));
})();

(function(){
  // Variant section updater:
  // data-update-section="sticky-atc-bar"   -> section ID (without "shopify-section-" prefix)
  // data-update-target=".inner"            -> optional: single selector inside section to replace
  // data-update-targets=".a, .b, .c"       -> optional: multiple selectors (comma-separated)
  // Conditional targets:
  //   .product__media-gallery:if(has-variant-images)
  //   .something:if(.exists-in-src)        // CSS selector in srcNode
  //   .block:ifnot(#absent-in-src)         // negated condition
  // Reversible logic: condition is also checked against current DOM (dest).
  // If the truthiness changed between dest and src, we update too.
  // data-view-transition="true"             -> optional: use HTMLUpdateUtility.viewTransition if available

  const SELECTOR = '[data-update-section]';

  let inFlight = null;
  let abortController = null;
  let queuedDetail = null;
  let debounceTimer = null;

  function collectSectionIds(){
    const ids = new Set();
    document.querySelectorAll(SELECTOR).forEach(el=>{
      const id = (el.getAttribute('data-update-section')||'').trim();
      if (id) ids.add(id);
    });
    return Array.from(ids);
  }

  function buildSectionsUrl(productUrl, sectionIds, { optionValues = [], variantId = null } = {}){
    const url = new URL(productUrl, window.location.origin);
    const params = new URLSearchParams(url.search);
    params.set('sections', sectionIds.join(','));
    if (optionValues.length) params.set('option_values', optionValues.join(','));
    if (variantId) params.set('variant', variantId);
    url.search = params.toString();
    return url.toString();
  }

  function parseSectionNode(htmlString, sectionId){
    const wrapper = document.createElement('div');
    wrapper.innerHTML = htmlString;
    return wrapper.querySelector(`#shopify-section-${sectionId}`) || wrapper.firstElementChild || wrapper;
  }

  function canDoVT(useTransition){
    return !!(useTransition && typeof HTMLUpdateUtility?.viewTransition === 'function');
  }

  function replaceDestination(dest, incoming, useTransition, pre=[], post=[]){
    if (canDoVT(useTransition)) {
      HTMLUpdateUtility.viewTransition(dest, incoming, pre, post);
    } else {
      dest.replaceWith(incoming);
    }
  }

  // --- Conditional targets parsing ---

  const TARGET_RE = /^(.*?)(?::(if|ifnot)\((.+?)\))?$/i;

  function normalizeTokens(listStr){
    return listStr.split(',').map(s=>s.trim()).filter(Boolean);
  }

  function parseTargetSpec(raw){
    const m = raw.match(TARGET_RE);
    if (!m) return null;
    const selector = (m[1]||'').trim();
    const mode = (m[2]||'').toLowerCase(); // 'if' | 'ifnot' | ''
    const token = (m[3]||'').trim();
    return { selector, mode, token };
  }

  function tokenIsSelector(token){
    return /^[.#\[]/.test(token) || /[\s>+~]/.test(token);
  }

  function tokenExists(node, token){
    if (!token) return false;
    if (tokenIsSelector(token)) {
      return !!node.querySelector(token);
    }
    return node.classList?.contains(token) || !!node.querySelector('.'+token);
  }

  function conditionHolds(node, mode, token){
    if (!mode) return true;
    const exists = tokenExists(node, token);
    return mode === 'if' ? exists : !exists;
  }

  function getMarkerTargetSpecs(marker){
    const single = marker.getAttribute('data-update-target') || '';
    const multi  = marker.getAttribute('data-update-targets') || '';
    const raw = [single, multi].filter(Boolean).join(',');
    return normalizeTokens(raw)
      .map(parseTargetSpec)
      .filter(Boolean)
      .filter(sp=>sp.selector);
  }

  // --- Difference check ---

  function serializeAttributes(el){
    const out = [];
    for (const {name, value} of Array.from(el.attributes).sort((a,b)=>a.name.localeCompare(b.name))) {
      out.push(name + '=' + JSON.stringify(value));
    }
    return out.join(';');
  }

  function serializeNodeDeep(el){
    const tag = el.tagName;
    const attrs = serializeAttributes(el);
    const clone = el.cloneNode(true);
    clone.querySelectorAll('script, style').forEach(n=>n.remove());
    const html = clone.innerHTML.trim();
    return `${tag}|${attrs}|${html}`;
  }

  function isMeaningfullyDifferent(a, b){
    try {
      if (!a || !b) return true;
      if (a.tagName !== b.tagName) return true;
      const A = serializeNodeDeep(a);
      const B = serializeNodeDeep(b);
      return A !== B;
    } catch {
      return true;
    }
  }

  // --- Core update ---

  async function updateSections(detail){
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const sectionIds = collectSectionIds();
    if (!sectionIds.length) return;

    const productUrl =
      detail?.productUrl ||
      document.querySelector('product-info')?.dataset?.url ||
      window.location.pathname;

    const reqUrl = buildSectionsUrl(productUrl, sectionIds, {
      optionValues: detail?.optionValues || [],
      variantId: detail?.variantId || null,
    });

    try {
      const res = await fetch(reqUrl, {
        signal: abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) return;

      const json = await res.json(); // { "<sectionId>": "<html>" }

      for (const id of sectionIds) {
        const html = json[id];
        if (!html) continue;

        const dest = document.getElementById(`shopify-section-${id}`);
        if (!dest) continue;

        const srcNode = parseSectionNode(html, id);

        const markers = Array.from(document.querySelectorAll(`${SELECTOR}[data-update-section="${id}"]`));
        const anyPartial = markers.some(m => m.hasAttribute('data-update-target') || m.hasAttribute('data-update-targets'));

        if (!anyPartial) {
          if (isMeaningfullyDifferent(dest, srcNode)) {
            const useTransition = markers.some(m => m.getAttribute('data-view-transition') === 'true');
            replaceDestination(dest, srcNode, useTransition);
          }
          continue;
        }

        // Aggregate selectors across markers; include selector if:
        // - condition holds on src (forward), OR
        // - truthiness changed between dest and src (reverse).
        const selectorMap = new Map(); // sel -> { useTransition: boolean }
        for (const marker of markers) {
          const specs = getMarkerTargetSpecs(marker);
          if (!specs.length) continue;
          const wantsTransition = marker.getAttribute('data-view-transition') === 'true';

          for (const spec of specs) {
            const forward = conditionHolds(srcNode, spec.mode, spec.token);
            const prev    = conditionHolds(dest,    spec.mode, spec.token);
            const changed = forward !== prev;

            if (!(forward || changed)) continue;

            const entry = selectorMap.get(spec.selector) || { useTransition: false };
            entry.useTransition = entry.useTransition || wantsTransition;
            selectorMap.set(spec.selector, entry);
          }
        }

        if (!selectorMap.size) continue;

        selectorMap.forEach(({ useTransition }, sel) => {
          const oldNodes = Array.from(dest.querySelectorAll(sel));
          const newNodes = Array.from(srcNode.querySelectorAll(sel));
          if (!oldNodes.length || !newNodes.length) return;

          const count = Math.min(oldNodes.length, newNodes.length);
          if (oldNodes.length !== newNodes.length) {
            console.warn(`[sections] Mismatch count for selector "${sel}" in section "${id}": old=${oldNodes.length} new=${newNodes.length}. Replacing ${count}.`);
          }

          for (let i = 0; i < count; i++) {
            const oldNode = oldNodes[i];
            const incoming = newNodes[i];

            if (!isMeaningfullyDifferent(oldNode, incoming)) continue;

            const fresh = incoming.cloneNode(true);
            replaceDestination(oldNode, fresh, useTransition);
          }
        });
      }

      document.dispatchEvent(new CustomEvent('sections:updated', {
        detail: { sectionIds, variantId: detail?.variantId || null }
      }));

      window?.Shopify?.PaymentButton?.init?.();
      window?.ProductModel?.loadShopifyXR?.();

    } catch (e) {
      if (e?.name !== 'AbortError') console.error('sections update failed:', e);
    } finally {
      inFlight = null;
    }
  }

  function scheduleUpdate(detail){
    queuedDetail = detail;
    if (inFlight) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(()=>{
      inFlight = updateSections(queuedDetail);
      queuedDetail = null;
    }, 50);
  }

  document.addEventListener('product:variant-updated', (e)=>{
    scheduleUpdate(e.detail || {});
  });

  if (document.querySelector(SELECTOR)) {
    scheduleUpdate({
      productUrl: document.querySelector('product-info')?.dataset?.url || window.location.pathname,
      variantId: new URLSearchParams(location.search).get('variant'),
      optionValues: [],
    });
  }
})();

(function() {
  const headerTop = document.querySelector('.header__top');
  const headerBottom = document.querySelector('.header__bottom');
  if (!headerTop) return;

  function updateHeight() {
    let totalHeight = headerTop.getBoundingClientRect().height;

    if (headerBottom) {
      const hasShow = headerBottom.classList.contains('is-show');
      const hasHide = headerBottom.classList.contains('is-hide');
      if (hasShow || !hasHide) {
        totalHeight += headerBottom.getBoundingClientRect().height;
      }
    }

    document.documentElement.style.setProperty('--header-top-height', `${totalHeight}px`);
  }

  window.addEventListener('load', updateHeight);
  window.addEventListener('resize', updateHeight);
  window.addEventListener('scroll', updateHeight, { passive: true });
})();


window.addEventListener('DOMContentLoaded', () => {
  const used = new Set([...document.querySelectorAll('[id]')].map(el => el.id));

  document.querySelectorAll('a[name]').forEach(el => {
    const raw = el.getAttribute('name');
    if (!raw) return;

    const base = raw.trim();
    let id = base.replace(/\s+/g, '-').replace(/[^\w\-:.]/g, '');
    if (!id) return;

    let uniq = id, i = 2;
    while (used.has(uniq)) uniq = `${id}-${i++}`;
    el.id = uniq;
    used.add(uniq);

    el.removeAttribute('name');

    if (!el.hasAttribute('href')) {
      const span = document.createElement('span');
      span.id = el.id;
      span.className = el.className;
      span.style.cssText = el.style?.cssText || '';
      while (el.firstChild) span.appendChild(el.firstChild);
      el.replaceWith(span);
    }
  });
});